<template>
  <div class="store-section">
    <div class="section-header">
      <h3>门店列表</h3>
    </div>

    <!-- 筛选表单 -->
    <el-form :inline="true" class="search-form">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="handleAddStore"
        :disabled="!selectedAppId"
      >新增门店</el-button>
      <el-form-item label="门店名称" style="margin: 0 20px 0" size="small">
        <el-input
          v-model="listQuery.store_name"
          placeholder="请输入门店名称"
          clearable
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-form-item label="老板姓名" style="margin: 0 20px 0 0" size="small">
        <el-input
          v-model="listQuery.boss_name"
          placeholder="请输入老板姓名"
          clearable
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-form-item label="门店电话" style="margin: 0 20px 0 0" size="small">
        <el-input
          v-model="listQuery.store_phone"
          placeholder="请输入门店电话"
          clearable
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-button type="primary" @click="search" size="small" icon="el-icon-search">搜索</el-button>
    </el-form>

    <!-- 表格 -->
    <div class="tableList">
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="status" slot-scope="{ row }">
          <el-tag v-if="row.status === 0" type="success">营业中</el-tag>
          <el-tag v-else-if="row.status === 1" type="warning">休息中</el-tag>
          <el-tag v-else type="danger">关闭</el-tag>
        </template>

        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button type="text" size="small" @click="handleEditStore(row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleDeleteStore(row)" class="text-red">删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>

    <!-- 门店新增/编辑弹窗 -->
    <el-drawer
      :title="storeDrawerTitle"
      :visible.sync="storeDrawerVisible"
      direction="rtl"
      size="700px"
      :close-on-click-modal="false"
    >
      <div class="drawer-content">
        <el-form :model="storeForm" :rules="storeFormRules" ref="storeForm" label-width="120px">
          <el-form-item label="门店名称" prop="store_name">
            <el-input v-model="storeForm.store_name" placeholder="请输入门店名称"></el-input>
          </el-form-item>
          <el-form-item label="老板姓名" prop="boss_name">
            <el-input v-model="storeForm.boss_name" placeholder="请输入老板姓名"></el-input>
          </el-form-item>
          <el-form-item label="门店电话" prop="store_phone">
            <el-input v-model="storeForm.store_phone" placeholder="请输入门店电话"></el-input>
          </el-form-item>
          <el-form-item label="门店地址" prop="store_addr">
            <el-input v-model="storeForm.store_addr" placeholder="请输入门店地址"></el-input>
          </el-form-item>
          <el-form-item label="经度" prop="latitude">
            <el-input v-model="storeForm.latitude" placeholder="请输入经度"></el-input>
          </el-form-item>
          <el-form-item label="纬度" prop="longitude">
            <el-input v-model="storeForm.longitude" placeholder="请输入纬度"></el-input>
          </el-form-item>
          <el-form-item label="工作时间" prop="workTime">
            <el-input v-model="storeForm.workTime" placeholder="例如：9:00-21:00"></el-input>
          </el-form-item>
          <!-- <el-form-item label="店长ID" prop="openid">
            <el-input v-model="storeForm.openid" placeholder="请输入店长ID"></el-input>
          </el-form-item>-->
          <el-form-item label="营业状态" prop="status">
            <el-radio-group v-model="storeForm.status">
              <el-radio :label="0">营业中</el-radio>
              <el-radio :label="1">休息中</el-radio>
              <el-radio :label="2">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="店铺头像" prop="storeImg">
            <el-input v-model="storeForm.storeImg" placeholder="请输入店铺头像URL"></el-input>
          </el-form-item>
          <el-form-item label="支付收款码" prop="payUrl">
            <el-input v-model="storeForm.payUrl" placeholder="请输入支付收款码URL"></el-input>
          </el-form-item>
          <el-form-item label="执照图" prop="zhizhaoImg">
            <el-input v-model="storeForm.zhizhaoImg" placeholder="请输入执照图URL"></el-input>
          </el-form-item>
          <el-form-item label="其他图" prop="otherImg">
            <el-input v-model="storeForm.otherImg" placeholder="请输入其他图URL"></el-input>
          </el-form-item>
        </el-form>
        <div class="drawer-footer">
          <el-button @click="storeDrawerVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSaveStore">保存</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import {
  selectApi as selectStoreApi,
  addApi as addStoreApi,
  updateApi as updateStoreApi,
  deleteApi as deleteStoreApi
} from "@/services/storeConfig/storeInfo";

export default {
  name: "StoreListSection",
  components: {
    ElTable
  },
  props: {
    selectedAppId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      listQuery: {
        appid: "",
        store_name: "",
        boss_name: "",
        store_phone: "",
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      storeDrawerVisible: false,
      isEditStore: false,
      storeForm: {
        store_id: "",
        appid: "",
        store_name: "",
        boss_name: "",
        store_phone: "",
        store_addr: "",
        latitude: "",
        longitude: "",
        workTime: "",
        openid: "",
        status: 0,
        storeImg: "",
        payUrl: "",
        zhizhaoImg: "",
        otherImg: ""
      },
      storeFormRules: {
        store_name: [
          { required: true, message: "请输入门店名称", trigger: "blur" }
        ],
        boss_name: [
          { required: true, message: "请输入老板姓名", trigger: "blur" }
        ],
        store_phone: [
          { required: true, message: "请输入门店电话", trigger: "blur" }
        ],
        store_addr: [
          { required: true, message: "请输入门店地址", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    listHeader,
    storeDrawerTitle() {
      return this.isEditStore ? "编辑门店信息" : "新增门店信息";
    }
  },
  watch: {
    selectedAppId: {
      handler(newVal) {
        if (newVal) {
          this.listQuery.appid = newVal;
          this.listQuery.pageNumber = 1;
          this.loadStoreList();
        } else {
          this.tableData = [];
          this.listQuery.total = 0;
        }
      },
      immediate: true
    }
  },
  methods: {
    async loadStoreList() {
      if (!this.listQuery.appid) {
        this.$message.warning("请先选择小程序应用");
        return;
      }

      this.loading = true;
      try {
        const res = await selectStoreApi(this.listQuery);
        if (res.code === 200) {
          this.tableData = res.data || [];
          this.listQuery.total = res.count || 0;
        }
      } catch (error) {
        this.$message.error("加载门店列表失败");
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 200);
      }
    },

    search() {
      this.listQuery.pageNumber = 1;
      this.loadStoreList();
    },

    handleCurrentChange(page) {
      this.listQuery.pageNumber = page;
      this.loadStoreList();
    },

    handleSizeChange(size) {
      this.listQuery.pageSize = size;
      this.listQuery.pageNumber = 1;
      this.loadStoreList();
    },

    handleAddStore() {
      if (!this.selectedAppId) {
        this.$message.warning("请先选择小程序应用");
        return;
      }

      this.isEditStore = false;
      this.storeForm = {
        store_id: "",
        appid: this.selectedAppId,
        store_name: "",
        boss_name: "",
        store_phone: "",
        store_addr: "",
        latitude: "",
        longitude: "",
        workTime: "",
        openid: "",
        status: 0,
        storeImg: "",
        payUrl: "",
        zhizhaoImg: "",
        otherImg: ""
      };
      this.storeDrawerVisible = true;
      this.$nextTick(() => {
        this.$refs.storeForm && this.$refs.storeForm.clearValidate();
      });
    },

    handleEditStore(store) {
      this.isEditStore = true;
      this.storeForm = { ...store };
      this.storeDrawerVisible = true;
      this.$nextTick(() => {
        this.$refs.storeForm && this.$refs.storeForm.clearValidate();
      });
    },

    handleSaveStore() {
      this.$refs.storeForm.validate(async valid => {
        if (valid) {
          try {
            const api = this.isEditStore ? updateStoreApi : addStoreApi;
            const res = await api(this.storeForm);
            if (res.code === 200) {
              this.$message.success(this.isEditStore ? "修改成功" : "新增成功");
              this.storeDrawerVisible = false;
              this.loadStoreList();
            } else {
              this.$message.error(res.message || "操作失败");
            }
          } catch (error) {
            this.$message.error("操作失败");
          }
        }
      });
    },

    handleDeleteStore(store) {
      this.$confirm("确定要删除该门店吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            const res = await deleteStoreApi({ store_id: store.store_id });
            if (res.code === 200) {
              this.$message.success("删除成功");
              this.loadStoreList();
            } else {
              this.$message.error(res.message || "删除失败");
            }
          } catch (error) {
            this.$message.error("删除失败");
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="less">
.store-section {
  flex: 1;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }
}

.search-form {
  margin-bottom: 15px;
  padding: 15px;
  background: #f9f9f9;
  border-radius: 4px;
}

.tableList {
  flex: 1;
  overflow: auto;
}

.operation {
  display: flex;
  gap: 10px;
}

.drawer-content {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.drawer-footer {
  margin-top: auto;
  padding-top: 20px;
  border-top: 1px solid #e6e6e6;
  text-align: right;
}
</style>
